'use strict';

import validator from "../validator";
import toasts from '../toast-notify';
import analytics from "../analytics";

let email_regx = validator.regex.email;
let numericRegEx = /^(([1-9]*)|(([1-9]*)\.([0-9]*)))$/;
let specialCharacterRegEx = /[!@#$%^&*()_+\=\[\]{};:"\\|,.<>\/?]+/;
let lastFocusedElement = null;


/**
 * Redesign Login Form
 * Validation Error Form 
 * Validation Passwords Form
 * Login Show
 * Login Hide
 * Logout / Social Login Toast Message
 * Forgot Password Email/ Sent
 * Checkout Login
 * */


/**
   * @function 
   * @description method to show the login modal dialog
   */
function loginShow() {
  lastFocusedElement = document.activeElement;
  $('html').addClass('modal-open');
  $('#login-wrapper-new').addClass('active');
  
  // Move focus into the panel
  $('#login-wrapper-new .login-header .title').focus();
  analytics.trackSignInDrawerOpen();
}

/**
   * @function 
   * @description method to hide the login modal
   */
function loginHide() {
  // Login & overlay - New Login slide out 
  $('html').removeClass('modal-open');
  $('#login-wrapper-new').removeClass('active');
  
  // Restore focus to Sign In button
  lastFocusedElement.focus();

}

/**
   * @function 
   * @description Back to Login when user close on second step or forgot link
   */
function loginRedesignStepOne() {
  if ($('.login-auth-registeruser').length || $('.account-registration-process').length || $('.reset-password-wrapper').length || $('.reset-password-success').length) {
    clearForm();
  }
}

/**
   * @function 
   * @description Email verification for the current user & new user credentials
   */
function userEmailAuth() {
  var $searchInput = $('.login-redesign-username .user-email input[type="email"]');
  $searchInput.on('focus keyup', function (e) {
    if (email_regx.test($searchInput.val())) {
      var $form = $('#dwfrm_login');
      var data = $form.serialize() + '&email=' + $searchInput.val();

      setTimeout(() => {
        $.ajax({
          url: Urls.loginOrRegister,
          data: data,
          type: "POST"
        }).done(function (response) {
          if (response.existingUser) {
            $searchInput.closest('.material-input').find('span.error').remove();
            $(".login-wrapper-new").addClass('loginAuth').removeClass('registerAuth');
            $(".account-search-msg-header, .account-registration-msg-header, .login-redesign-registration-form, .account-registration-process, .login-auth-registeruser .error-form, .reset-account-part").addClass("visually-hidden");
            $('.login-redesign-username .user-email input').addClass('valid');
            $(".account-login-msg-header, .reset-password-link, .login-auth-registeruser, .login-redesign-password").removeClass("visually-hidden");
            $(".login-redesign-password").removeClass("registration");
            $(".login-drawer-banner").removeClass("visually-hidden");

            $('.login-redesign-password .input-text').val() !== '' && $('.login-redesign-password .material-input').addClass('focus-in');
            $('.login-redesign-username .input-text').val() !== '' && $('.login-redesign-username .material-input').addClass('focus-in valid');
            validator.initForm('.login-auth-email');
            validateFormLogin();
          } else {
            $searchInput.closest('.material-input').find('span.error').remove();
            $(".login-wrapper-new").addClass('registerAuth').removeClass('loginAuth');
            $(".login-redesign-password").addClass("registration").removeClass('visually-hidden');
            $(".login-redesign-username .user-email").addClass("focus-in valid");
            $('.login-redesign-username .user-email input').addClass('valid');
            $(".account-registration-msg-header, .login-redesign-registration-form, .account-registration-process, #login-wrapper-new .divider, #login-wrapper-new .social-login-holder").removeClass("visually-hidden");
            $(".account-login-msg-header, .reset-password-link, .login-auth-registeruser, .account-search-msg-header, .registration .error-form, .reset-account-part").addClass("visually-hidden");
            $(".login-drawer-banner").addClass("visually-hidden");
            
            $('.registration .input-text').val() !== '' && $('.registration .material-input').addClass('focus-in');
            $('.login-redesign-username .input-text').val() !== '' && $('.login-redesign-username .material-input').addClass('focus-in valid');

            $('.login-auth-email input').removeClass('error');
            $('.login-auth-email span.error').remove();
            validateInputs();
            validateFormLogin();
            registerPasswordValidator();
            $('.registration input').val() === '' && $('.registration .material-input').removeClass('focus-in');
            if($('.registration  .material-input .input-text:-webkit-autofill').length) {
                $('.registration  .material-input .input-text').trigger('focus');
            }
          }
        });
      }, 500);

    } else {
      return;
    }
  });
}

/**
   * @function 
   * @description Email & password validation for login
   */
function loginSuccessRedesign() {
  $('#login-user').on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var form = $('#dwfrm_login');
    var data = form.serialize() + '&format=ajax';
    $('.error-form.invalid').remove();

    const $loginWrapper = $('#login-wrapper-new'); // Created a variable for reuse

    $.ajax({
      url: Urls.loginForm,
      data: data,
      type: "POST"
    }).done(function (response) {
      if (response && response.errorCode && response.errorCode === 'ERROR_PASSWORD_EXPIRED') {
        $('.login-redesign-password-expiry').removeClass('visually-hidden');
      } else if (response && response.errorCode && response.errorCode === 'accountLocked') {
        $('.login-redesign-login-locked').removeClass('visually-hidden');
      } else if (response && response.errorCode && response.errorCode === 'remainingLoginAttempts') {
        $('.login-redesign-login-willbelocked').removeClass('visually-hidden');
      } else if (response && response.invalidCredentials) {
        $('.login-redesign-login-error').removeClass('visually-hidden');
      }

      setTimeout(() => {
        validateFormLogin();
      }, 1000);

      if (response && response.invalidCredentials) {
        $loginWrapper.find('input.error').length && $loginWrapper.find('input').removeClass('error');
        $loginWrapper.find(".user-email").addClass("focus-in");
        $loginWrapper.find('.login-auth-registeruser .user-email').addClass('valid');
      } else {
        $loginWrapper.find('.login-form-content-new').html(response);
        $loginWrapper.find('.divider').remove();
        $loginWrapper.find('.social-login-holder').remove();
        $loginWrapper.find('.login-content-new').addClass('animate__fadeInDown');

        let wishListLink = localStorage.getItem('wishListLink');
        if (wishListLink) {
        
          window.location.href = wishListLink + '&source=wishlistRedesign';
          // Optionally, remove it from localStorage if you only need to use it once
          localStorage.removeItem('wishListLink');
        }

        setTimeout(() => {
          $loginWrapper.find('.login-close').trigger('click');
          if (wishListLink) {
          
            window.location.href = wishListLink + '&source=wishlistRedesign';
            // Optionally, remove it from localStorage if you only need to use it once
            localStorage.removeItem('wishListLink');
          }
          if (window.location.href.indexOf("Login-Show") >= 0) {
            document.location.href = Urls.myAccount;
          } else {
            $('html').addClass('modal-open');
            location.reload();
          }
        }, 1000);
      }
    });
  });
}


/**
   * @function 
   * @description Account created successfully
   */
function accountCreatedSuccess() {
  $('#register-user').on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $form = $('#dwfrm_login');
    var data = $form.serialize() + '&format=ajax';
  
    if(validateRegisterForm()) {
      $.ajax({
        url: Urls.registrationFormSubmitRedesign,
        data: data,
        type: "POST"
      }).done(function (response) {
        $('.registerAuth .login-form-content-new').html(response);
        if ($('#login-wrapper-new .registration-success-wrapper').length) {
          $('#login-wrapper-new .divider').remove();
          $('#login-wrapper-new .social-login-holder').remove();
          $('#login-wrapper-new .login-content-new').addClass('animate__fadeInDown');
          localStorage['AccountRegistered'] = true;
          let wishListLink = localStorage.getItem('wishListLink');
          if (wishListLink) {
        
            window.location.href = wishListLink + '&source=wishlistRedesign';
              // Optionally, remove it from localStorage if you only need to use it once
              localStorage.removeItem('wishListLink');
          }
          setTimeout(() => {
            $('#login-wrapper-new .login-close').trigger('click');
            location.reload();
          }, 3000);
        }
      });
    }
  });
}

/**
   * @function 
   * @description Password validation
   */
function validateFormLogin() {
  var emailInput = $('.login-redesign-username .user-email input[type="email"]');
  var passwordInput = $('.login-redesign-password .user-pass input');
  var submitBtn = $('#login-user');
  var firstName = $('.first-name');
  var lastName = $('.last-name');
  var agreeCheckbox = $('.user-consent-registration .termsandconditions');

  var email_regx = validator.regex.email;
  // Email Validation - Input
   function handleEmailChange(e) {
    if (email_regx.test(emailInput.val())) {
      $('.login-redesign-password .user-email input').addClass('valid');
    } else {
      $('.login-redesign-password .user-email input').removeClass('valid');
    }
  }

  // Password Validation - Input
  function handleInputChange() {
    if (passwordInput.val() !== '' && passwordInput.val().length >= 8 && emailInput.val() !== '') {
      submitBtn.prop("disabled", false);
      submitBtn.removeClass('disabled');
      $(firstName).find('input').removeClass('error');
      $(firstName).find('span.error').remove();
      $(lastName).find('input').removeClass('error');
      $(lastName).find('span.error').remove();
      $(agreeCheckbox).removeClass('error');
      $(agreeCheckbox).closest('.material-input').find('span.error').remove();
    } else {
      submitBtn.prop("disabled", true);
      submitBtn.addClass('disabled');
    }
  }

  if ($(emailInput).val() !== '') {
    $(emailInput).closest('.material-input').addClass('focus-in');
  }

  if ($(passwordInput).val() !== '') {
    $(passwordInput).closest('.material-input').addClass('focus-in');
  }

  if ($(passwordInput).val() == '') {
    $(submitBtn).addClass('disabled');
    $('.login-redesign-password .user-pass .input-text').closest('.material-input').removeClass('focus-in');
  }

  emailInput.on('focus keyup blur', handleEmailChange);
  !$('.registerAuth').length > 0 && passwordInput.on('focus keyup blur', handleInputChange);
}

/**
   * @function 
   * @description Registration Password validation function
   */
function registerPasswordValidator() {
  var passwordInput = $('.login-redesign-password input');
  var emailInput = $('.login-redesign-username input')
  var submitBtn = $('#register-user');
  var firstName = $('.first-name input');
  var lastName = $('.last-name input');
  var agreeCheckbox = $('.user-consent-registration .termsandconditions');
  var newsletterCB = $('.user-consent-newsletter .addtoemaillist');

  function handleInputChange() {
    if (firstName.val() !== '' &&
      lastName.val() !== '' &&
      emailInput.val() !== '' &&
      passwordInput.val() !== '' &&
      $('#password_length').hasClass('valid') &&
      $('#password_number').hasClass('valid') &&
      $('#password_special').hasClass('valid')) {
        submitBtn.prop("disabled", false);
        submitBtn.removeClass('disabled');
    } else {
      submitBtn.prop("disabled", true);
      submitBtn.addClass('disabled');
    }
  }

  function handlePasswordRules() {
    if (!$('#password_length').hasClass('valid') || !$('#password_number').hasClass('valid') || !$('#password_special').hasClass('valid')) {
      $('#password_rules').show();
    } else {
      $('#password_rules').hide();
    }
  }
  
  agreeCheckbox.on('change', handleInputChange);
  passwordInput.on('focus keyup change', validateInputs);
  passwordInput.on('focus keyup change ', handlePasswordRules);
  passwordInput.on('focus keyup blur', handleInputChange);
  firstName.on('focus keyup blur', handleInputChange);
  lastName.on('focus keyup blur', handleInputChange);
  emailInput.on('focus keyup blur', handleInputChange);
}

function validateInputs() {
  var password = $('.login-redesign-password input').val(),
    all_pass = true;

  var number = password.match(/[0-9]/), // Number
    alpha = password.match(/[a-zA-Z]/), // Alphabet
    speCharacter = password.match(/^(?=.*[_\W]).+$/); // Special character 

  if (password.length < 8) {
    $('#password_length').removeClass('valid');
    $('#password_length .icon').removeClass('checkmark-valid').addClass('icon-close');
    all_pass = false;
  } else {
    $('#password_length').addClass('valid');
    $('#password_length .icon').removeClass('icon-close').addClass('checkmark-valid');
  }

  if (number) {
    $('#password_number').addClass('valid');
    $('#password_number .icon').removeClass('icon-close').addClass('checkmark-valid');
  } else {
    $('#password_number').removeClass('valid');
    $('#password_number .icon').removeClass('checkmark-valid').addClass('icon-close');
    all_pass = false;
  }

  if (speCharacter) {
    $('#password_special').addClass('valid');
    $('#password_special .icon').removeClass('icon-close').addClass('checkmark-valid');
  } else {
    $('#password_special').removeClass('valid');
    $('#password_special .icon').removeClass('checkmark-valid').addClass('icon-close');
    all_pass = false
  }
}

function firstNameValidation() {
  let validateName = validator.regex.name;
  return [
    validateName.test($('.first-name input').val()),
    !numericRegEx.test($('.first-name input').val()),
    !specialCharacterRegEx.test($('.first-name input').val()),
  ].every(Boolean);
}

function lastNameValidation() {
  let validateName = validator.regex.name;
  return [
    validateName.test($('.last-name input').val()),
    !numericRegEx.test($('.last-name input').val()),
    !specialCharacterRegEx.test($('.last-name input').val()),
  ].every(Boolean);
}

function validateRegisterForm() {
  const [
    email,
    emailValid,
    firstName,
    lastName,
    password,
    agreeTerms,
    lengthValid,
    numberValid,
    specialValid,
  ] = [
      $('.login-redesign-username input').val(),
      email_regx.test($('.login-redesign-username input').val()),
      firstNameValidation(),
      lastNameValidation(),
      $('.login-redesign-password input').val(),
      $('.user-consent-registration .termsandconditions').is(':checked'),
      $('#password_length').hasClass('valid'),
      $('#password_number').hasClass('valid'),
      $('#password_special').hasClass('valid'),
    ];

  return [email, emailValid, firstName, lastName, password, agreeTerms, lengthValid, numberValid, specialValid].every(Boolean);
}

/**
   * @function 
   * @description Password Show Hide Toggle functionality
   */
function passwordShowHideToggle() {
  const passwordInput = $('.login-redesign-password .user-pass input');
  $('.login-redesign-password .user-pass').on('click', '.icon-eye', function () {
    $(this).removeClass('icon-eye').addClass('icon-eye-slash');
    $(passwordInput).attr("type", "text");
  });
  
  $('.login-redesign-password .user-pass').on('click', '.icon-eye-slash', function () {
    $(this).removeClass('icon-eye-slash').addClass('icon-eye');
    $(passwordInput).attr("type", "password");
  });
}

/**
   * @function 
   * @description Clear / Empty form data
   */
function clearForm() {
  setTimeout(() => {
    var formData = $('.login-auth-email');
    $(formData).find('input:not(.data-field)').val('').removeClass('error');
    $(formData).find('span.error').remove();
    $(formData).find('.icon_checkmark').remove();
    $(formData).find('.material-input').removeClass('focus-in');
    $('.login-form-content-new, .account-search-msg-header, .divider, .social-login-holder').removeClass('visually-hidden');
    $(".login-redesign-password, .account-login-msg-header, .account-registration-msg-header, .reset-password-link, .login-auth-registeruser, .account-registration-process, .login-redesign-registration-form, .login-redesign-password .error-form, .reset-account-part").addClass("visually-hidden");
    $('.login-redesign-password .user-pass .icon.icon-eye-slash').length > 0 && $('.login-redesign-password .user-pass .icon-eye-slash').trigger('click');
    $('.login-auth-email').find('input[type=checkbox]').is(':checked') && $('.login-auth-email').find('input[type=checkbox]').trigger('click');
    $('.reset-password-wrapper').addClass('visually-hidden').removeClass('animate__fadeInDown');
    $('.reset-password-success').addClass('visually-hidden').removeClass('animate__fadeIn');
  }, 300);
}


/**
   * @function 
   * @description Forgot Password Link send email button click - step for forgot password
   */
function resetPasswordSendLink() {
  $(document).on('click', '#login-wrapper-new .password-reset-link', function (e) {
    e.preventDefault();
    var userEmail = $('.login-redesign-username .user-email input[type="email"]').val();
    $('.reset-password-wrapper .user-email').html(userEmail);
    $('.login-form-content-new').addClass('visually-hidden')
    $('#login-wrapper-new .divider').addClass('visually-hidden');
    $('#login-wrapper-new .social-login-holder').addClass('visually-hidden');
    $('.reset-password-wrapper').removeClass('visually-hidden').addClass('animate__fadeInDown');
    $('.reset-link-btn').data('email', userEmail);
  });
}

/**
   * @function 
   * @description Forgot Password email send to the user email - Last Step for forgot password
   */
function resetPasswordSendEmail() {
  $(document).on('click', '#login-wrapper-new .reset-link-btn', function (e) {
    e.preventDefault();
    var email = $(this).data('email');
    $('.reset-password-wrapper, .reset-account-part').addClass('visually-hidden');
    $('.reset-password-success').removeClass('visually-hidden').addClass('animate__fadeIn');
    $.ajax({
      url: Urls.resetPasswordSendEmail + '?email=' + email,
      type: "POST"
    }).done(function (response) {
      setTimeout(() => {
        loginHide();
        loginRedesignStepOne();
      }, 5000);
    });
  });
}

function newpasswordconfirm() {
  $('.reset-account-part').on('click', '#NewPasswordForm button', function (e) {
    e.preventDefault();
    const $form = $('#NewPasswordForm');
    const $password = $form.find('.userpass input[type="password"]');
    const $passwordconfirm = $form.find('.userpass .passwordconfirm');
    const data = $form.serialize() + '&password=' + $password.val() + '&confirmpassword=' + $passwordconfirm.val();
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      $.ajax({
        url: Urls.setNewPasswordFormRedesign + '?Token=' + urlParams.get('Token'),
        data: data,
        type: "POST"
      }).done(function (response) {
        if (response && response.ErrorCode) {
          const errorKey = `ACCOUNT_PASSWORDRESET_${response.ErrorCode}`;
          const errorMessage = Resources[errorKey];

          // Display the error message
          const errorContainer = document.getElementById('error-message-container');
          errorContainer.textContent = errorMessage;
          errorContainer.classList.remove('visually-hidden');
      } else if (response && response.isPasswordChanged) {
          $('.reset-account-part').addClass('visually-hidden');
          $('.setnewpasswordconfirm').removeClass('visually-hidden');
          setTimeout(() => {
            if (response && response.ContinueURL) {
              // Redirect to the URL
              window.location.href = response.ContinueURL;
            } 
            
          }, 500);
        }
      });
    
    }
  });
}

/**
   * @function 
   * @description User logged out successfully, able to see toast dialog
   */
function loggedOut() {
  if (localStorage.userAuth == "loggedOut") {
    toasts.init($('#logged-out-success').val(), 'active animate__fadeInDownToast', 'icon-sign-out');
    localStorage.removeItem('userAuth');
  } else {
    if ($('.logged-out-success').length) {
      $('.logged-out-success').remove();
    }
    $(".user-logout").on('click', function () {
      localStorage.setItem("userAuth", "loggedOut");
    })
  }
}

/**
   * @function 
   * @description Checkout login modal dialog
   */
function checkoutLogin() {

  var checkoutEmail = $('.checkout-login-container input[type="email"]');
  checkoutEmail.on('focus keyup keydown', function (e) {
    var email_regx = validator.regex.email;
    if (email_regx.test(checkoutEmail.val())) {
      setTimeout(() => {
        $.ajax({
          url: Urls.loginOrRegister + '?email=' + checkoutEmail.val(),
          type: "POST"
        }).done(function (response) {
          if (response.existingUser) {
            $('.user-auth-existing').removeClass('hidden');
            $('.user-auth-guest').addClass('hidden');
          } else {
            $('.user-auth-existing').addClass('hidden');
            $('.user-auth-guest').removeClass('hidden');
          }
        });
      }, 200);
    } else {
      return;
    }
  });
  
  $(document).on("click", ".checkout-login-container .checkout-login-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var emailInput = $('.login-redesign-username .user-email input[type="email"]');
    var passInput = $('.login-redesign-password .input-text');
    $(emailInput).val($(checkoutEmail).val());
    $(emailInput).trigger('focus');
    $("<i class='icon_checkmark'></i>").insertBefore($(emailInput));
    $(passInput).val() == '' && $(passInput).removeClass('error');
    analytics.trackClickCtaAccountModal();
    loginShow();
  });
}

$('.my-account-link, #save-for-later, .add-to-wishlist').on('click', function(event) {
  // Prevent the default action (no redirection)
  event.preventDefault();
  let wishListLink = $(this).data('href');
  localStorage.setItem('wishListLink', wishListLink);
  // Trigger the click on the target element
  $('.sign-in-wrapper .myaccount').trigger('click');
})

var redesignLogin = {
  /**
   * @function
   * @description method to init redesignLogin
   */
  init: function () {
    // Login show
    $(document).on('click', '.sign-in-wrapper .myaccount', function (e) {
      if (!window.User.isCustomerAuthenticated) {
        e.preventDefault();
        e.stopPropagation();
        if (window.location.search) {
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('forgotpassword') === 'true') {
            // Call the loginShow() function
            loginShow();
            $('.login-form-content-new').addClass('visually-hidden')
            $('#login-wrapper-new .divider').addClass('visually-hidden');
            $('#login-wrapper-new .social-login-holder').addClass('visually-hidden');
            $('.reset-account-part').removeClass('visually-hidden');
          } else {
            loginShow();
            $('.user-pass .tooltip a').attr("href", "javascript:void(0)");
            if($(window).width() < 768 && !$(this).find('svg').length){
              $('.mobile-navigation .mobile-menu-wrapper .close-button').trigger('click');
            }
          }
        } else {
          loginShow();
          $('.user-pass .tooltip a').attr("href", "javascript:void(0)");
          if($(window).width() < 768 && !$(this).find('svg').length){
            $('.mobile-navigation .mobile-menu-wrapper .close-button').trigger('click');
          }
        }
      } else {
        let wishListLink = localStorage.getItem('wishListLink');
        if (wishListLink) {
        
          window.location.href = wishListLink +  '&source=wishlistRedesign';
          // Optionally, remove it from localStorage if you only need to use it once
          localStorage.removeItem('wishListLink');
        }
      }
    });

    // Login & overlay - Login hide 
    $('#login-wrapper-new .login-close, #login-wrapper-new .login-overlay').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      loginHide();
      loginRedesignStepOne();
    });
    
    $('.guest-header-message button, .pdp-login-banner .guest-header-message').on('click', function (e) {
      if (!window.User.isCustomerAuthenticated) {
        if (pageInfo.pageCategory === 'Home Page') {
          var loginLocation = null;
          if ($(this).closest('.homepage-first-login-banner').length) {
            loginLocation = 'top_location';
          } else if ($(this).closest('.homepage-second-login-banner').length) {
            loginLocation = 'bottom_location';
          }
          analytics.trackClickCtaAccountModal(loginLocation);   
        } else {
          analytics.trackClickCtaAccountModal();
        }
        loginShow();
      }
    });

    //perks CTA click (the anchor/arrow)
    $('a.guest-header-message').
    on('click', function (e) {
        analytics.trackClickCtaPerksAccountModal();
    });

    userEmailAuth();
    loggedOut();
    loginSuccessRedesign();
    resetPasswordSendLink();
    resetPasswordSendEmail();
    newpasswordconfirm();
    accountCreatedSuccess();
    passwordShowHideToggle();
    // Social login toast alert dialog
    if ($('.social-login-success').length) {
      var toast = $(".toast-container");
      toast.addClass('active animate__fadeInDownToast');
      window.setTimeout(function () {
          toast.removeClass('animate__fadeInDownToast').addClass('animate__fadeInUpToast');
          toast.remove();
      }, 3000);
    }

    if(window.User.isSocialNewlyRegistered) {
      localStorage['AccountRegistered'] = true;
    }
        // Login show on checkout only
        if ($('.pt_checkout').length) {
          checkoutLogin();
        }

    if (window.User.isCustomerAuthenticated && window.User.isCustomerAuthenticated) {
      $('#login-wrapper-new').remove();
    }

    if ($('#login-wrapper-new').length > 0) {
      $('.mobile-navigation .mobile-menu-bottom .sign-in-wrapper .myaccount').attr('href', '');
    }
    
   // Personalization Opt-in Checkbox - Accessibility Controller
    let $emailCheckbox = $('#dwfrm_profile_customer_addtoemaillist');
    let $personalizationCheckbox = $('#dwfrm_profile_account_consentpref');
    let $personalizationWrapper = $personalizationCheckbox.closest('.user-consent-personalization-wrapper');
    let $liveRegion = $('#personalization-live-region');
    let $hintElement = $('#personalization-hint');

    if (
        !$emailCheckbox.length ||
        !$personalizationCheckbox.length ||
        !$liveRegion.length
    ) {
        return;
    }

    // Enable the personalization checkbox
    function enablePersonalization() {
        $personalizationCheckbox
            .attr('aria-disabled', 'false')
            .removeAttr('aria-describedby');

        if ($personalizationWrapper.length) {
            $personalizationWrapper.addClass('is-enabled');
        }

        // Live region announcement
        announceLive('La casella di controllo per la personalizzazione è ora disponibile.');
    }

    // Disable the personalization checkbox and uncheck it
    function disablePersonalization() {
        $personalizationCheckbox
            .attr('aria-disabled', 'true')
            .attr('aria-describedby', 'personalization-hint')
            .prop('checked', false);

        if ($personalizationWrapper.length) {
            $personalizationWrapper.removeClass('is-enabled');
        }

        // Live region announcement
        announceLive(
            'Vorrei che le mie comunicazioni fossero personalizzate in base alle mie preferenze. ' +
            'Campo opzionale, casella di controllo, non selezionata, disabilitata.'
        );
    }

    // Announce message via live region
    let announceTimeout;
    function announceLive(message) {
        if (announceTimeout) {
            clearTimeout(announceTimeout);
        }

        $liveRegion.text('');

        announceTimeout = setTimeout(function () {
            $liveRegion.text(message);
        }, 100);
    }

    // Email checkbox change handler
    $emailCheckbox.on('change', function () {
        if ($(this).prop('checked')) {
            enablePersonalization();
        } else {
            disablePersonalization();
        }
    });

    // Block Space key activation when checkbox is aria-disabled
    $personalizationCheckbox.on('keydown', function (e) {
        if ($(this).attr('aria-disabled') === 'true' && (e.key === ' ' || e.which === 32 || e.key === 'Enter')) {
            e.preventDefault();
            e.stopPropagation();
        }
    });
    
    $personalizationCheckbox.on("click", function (e) {
      if ($(this).attr("aria-disabled") === "true") {
          e.preventDefault();
          e.stopPropagation();
      }
    });

    // Block clicks on associated label
    $('label[for="dwfrm_profile_account_consentpref"]').on('click', function (e) {
        if ($personalizationCheckbox.attr('aria-disabled') === 'true') {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    // Ensure correct state on page load
    if ($emailCheckbox.prop('checked')) {
        enablePersonalization();
    } else {
        $personalizationCheckbox.attr('aria-disabled', 'true').attr('aria-describedby', 'personalization-hint');
    }
  },
  loginShow: loginShow,
  loginHide: loginHide
};

export default redesignLogin;
